// อักขระที่ Firebase RTDB ห้ามใช้ในชื่อ key : . $ # [ ] / และ control character
// Firestore doc id ห้าม / เป็นหลัก ตัดชุดเดียวกันไปเลยจะได้ใช้ key ร่วมกันได้ทั้งสองที่
const FORBIDDEN_IN_KEY = /[.$#[\]/\x00-\x1F\x7F]/g;

// RTDB จำกัดชื่อ key ไว้ 768 ไบต์ ถ้าเกินจะ set() ไม่ผ่านแล้ว job หายทั้งใบ
// ตัดให้พอดีเป็นตัวอักษร (ไม่ตัดกลาง byte ของ UTF-8 ซึ่งจะได้อักขระเสีย)
// 200 ไบต์ = ไทยราว 66 ตัว เกินพอสำหรับชื่อโต๊ะจริง และเหลือที่ให้ timestamp สบาย ๆ
const MAX_TABLE_PART_BYTES = 200;

const truncateToBytes = (value: string, maxBytes: number): string => {
  const encoder = new TextEncoder();
  if (encoder.encode(value).length <= maxBytes) return value;

  let out = "";
  for (const char of value) {
    if (encoder.encode(out + char).length > maxBytes) break;
    out += char;
  }
  return out;
};

export const utilsSanitizeKeyPart = (value: any): string => {
  // MOVE ส่ง table มาเป็น array [โต๊ะเดิม, โต๊ะใหม่]
  const raw = Array.isArray(value) ? value.join("-") : value;

  const cleaned = String(raw ?? "")
    .replace(FORBIDDEN_IN_KEY, "")
    // เว้นวรรคไม่ผิดกฎ แต่ทำให้ key อ่านยากและพลาดง่ายเวลา debug
    .replace(/\s+/g, "");

  return truncateToBytes(cleaned, MAX_TABLE_PART_BYTES);
};

// key ของ job = {timestamp}_{โต๊ะ}
//
// ทำไมต้องมีโต๊ะต่อท้าย:
// หนึ่งโต๊ะมีคนรับออเดอร์ทีละคน job ของโต๊ะเดียวกันจึงไม่ชน millisecond กันเอง
// ส่วนคนละโต๊ะที่บังเอิญได้เวลาตรงกัน (นาฬิกาทุกเครื่องถูกดึงให้ตรง server time)
// จะถูกแยกด้วยชื่อโต๊ะ ไม่เขียนทับกันจน job หายอีก
//
// ยังคง idempotent อยู่: key คำนวณจากตัว job ล้วน ไม่ได้ใช้ id ของเครื่องที่เขียน
// ดังนั้นส่งซ้ำ (offline queue retry / แคชเชียร์สองเครื่องรับ QR order ใบเดียวกัน)
// ยังได้ key เดิมเสมอ -> set() ทับตัวเอง ไม่เกิดรายการซ้ำ
export const utilsJobKey = (job: any): string => {
  const timestampPart = String(job?.timestamp ?? "").replace(/\./g, "_");
  const tablePart = utilsSanitizeKeyPart(job?.table);

  // เปิด/ปิดร้าน ไม่มีโต๊ะ ใช้ timestamp ล้วนเหมือนเดิม
  return tablePart ? `${timestampPart}_${tablePart}` : timestampPart;
};
